import React from 'react'

export const PageHeader = (props) => {
    return (
        <div className="my-3">
            { props.title && <h1 className="mt-5">{props.title}</h1> }
            { props.description && <p className="lead">{props.description}</p> }
        </div>
    );
}